import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import propTypes from 'prop-types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const MultiBarChart =({chartLabels, chartData, ...rest})=> {
  const options = {
    indexAxis: 'x',
    scales : {
      y: {
        title: {
          display: true,
          text: rest.yAxisLabel,
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / 60);
             return {
               size: size
            };
          }
        },
        min: 0,
        max: rest.yAxisMax,
        ticks: {
          callback: value =>{
            return value + "%"
          },
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / 60);
             return {
               size: size
            };
          },
        }  
      },
      x:{
        title: {
          display: true,
          text: rest.xAxisLabel,
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / 60);
             return {
               size: size
            };
          }
        },
        ticks: {
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / 75);
             return {
               size: size
            };
          },
          maxRotation: 0,
          minRotation: 0
        }
      }
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: rest.title,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (item)=>rest.isPercent ? `${item.formattedValue}%` : `${item.formattedValue}`,
          title: (item)=>item[0].label.replace(",", " ")
        }
      }
    },
  };

  const labels = chartLabels;
  const data = {
    labels,
    datasets: [
      {
        label: rest.dataSetLabel1,
        data: rest.dataSet1,
        backgroundColor: rest.dataSet1BackgroundColor,
        borderColor: "#000"
      },
      {
        label: rest.dataSetLabel2,
        data: rest.dataSet2,
        backgroundColor: rest.dataSet2BackgroundColor,
        borderColor: "#000"
      },
    ]
  };

  return (
    <div className="desktop:display-block mobile:display-none">
      <Bar options={options} data={data} aria-label={`${rest.title}.`}/>
    </div>
  );
}

export default MultiBarChart;

MultiBarChart.propTypes = { 
  title: propTypes.string,
  chartLabels: propTypes.array,
  dataSet1: propTypes.array,
  dataSet2: propTypes.array,
  dataSetLabel1: propTypes.string,
  dataSetLabel2: propTypes.string,
  xAxisLabel: propTypes.string,
  yAxisLabel: propTypes.string,
  dataSet1BackgroundColor: propTypes.array,
  dataSet2BackgroundColor: propTypes.array,
  yAxisMax: propTypes.number,
  isPercent: propTypes.bool
}
MultiBarChart.defaultProps = {
  title: "",
  chartLabels: [],
  dataSet1: [],
  dataSet2: [],
  dataSetLabel1: "",
  dataSetLabel2: "",
  xAxisLabel: "",
  yAxisLabel: "",
  dataSet1BackgroundColor: ['rgb(21, 80, 132)'],
  dataSet2BackgroundColor: ['rgb(137, 69, 133)'],
  yAxisMax: 50,
  isPercent: false
}